<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">EIAJ検収伝票発行</span>
      </v-card-title>
      <v-card-text>
        <h3>处理Point</h3>
        <ol>
          <li></li>
        </ol>
        <h3>2018 12 20</h3>
        <ol>
          <li>打印EIAJ时，要添加条码的生成</li>
          <li>核销画面（No 5，自动核销）的【验收单号】就是【弹票号码】</li>
        </ol>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      username: null,
      password: null
    }
  }
}
</script>
<style scoped>
.login {
  position: absolute;
  top: 100px;
  right: 300px;
  width: 400px;
}
</style>
